import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
// primereact
import { Steps } from "primereact/steps";
// components
import Plans from "./Plans/Plans.jsx";
import FormData from "./FormData/FormData.jsx";
// services
import { useAppContext } from "../../context/AppContext.jsx";
//pages
import Payment from "./Payment/Payment.jsx";
//context
import { useCreateAccountContext } from "../../context/CreateAccountContext.jsx";
//assets
import darkLogo from "../../assets/darkLogo.png";
import progress1 from "../../assets/progress/papel.mp4";
import progress2 from "../../assets/progress/assina.mp4";
import progress3 from "../../assets/progress/cartao.mp4";

const CreateAccount = () => {
  const divRef = useRef(null);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const slug = searchParams.get("slug");
  const [divHeight, setDivHeight] = useState("100vh");
  const [video, setVideo] = useState(progress1);
  const [textLoading, setTextLoading] = useState("Estamos criando a sua conta");
  const [isTransitioning, setIsTransitioning] = useState(false);

  const { plan, activeIndex, loading, setActiveIndex, baseDataForm } =
    useCreateAccountContext();

  const {
    handleSetAppSidebarNone,
    handleSetAppHeaderNone,
    handleSetAppContentClass,
  } = useAppContext();

  useEffect(() => {
    handleSetAppSidebarNone(true);
    handleSetAppHeaderNone(true);
    handleSetAppContentClass("p-0");

    const updateDivHeight = () => {
      if (divRef.current) {
        const divHeightPx = divRef.current.scrollHeight;
        const viewportHeightPx = window.innerHeight;

        if (divHeightPx > viewportHeightPx) {
          setDivHeight("100%");
        } else {
          setDivHeight("100vh");
        }
      }
    };

    updateDivHeight();
    window.addEventListener("resize", updateDivHeight);

    return () => {
      window.removeEventListener("resize", updateDivHeight);
    };
  }, [
    handleSetAppSidebarNone,
    handleSetAppHeaderNone,
    handleSetAppContentClass,
    activeIndex,
  ]);

  const items = [
    {
      label: "Cadastro",
    },
    {
      label: "Planos",
    },
    {
      label: "Pagamento",
    },
  ];

  useEffect(() => {
    if (loading) {
      setTimeout(() => {
        handleContentChange(
          progress2,
          "Estamos gerando seu contrato para assinatura"
        );
      }, 5000);

      setTimeout(() => {
        handleContentChange(
          progress3,
          "Estamos validando os seus dados para pagamento"
        );
      }, 10000);
    }
  }, [loading]);

  useEffect(() => {
    if (slug) {
      if (slug !== localStorage.getItem("slug")) {
        localStorage.setItem("slug", slug);
      }
    }
  }, [slug]);

  const handleContentChange = (newVideo, newText) => {
    setIsTransitioning(true);
    setTimeout(() => {
      setVideo(newVideo);
      setTextLoading(newText);
      setIsTransitioning(false);
    }, 500);
  };

  return (
    <>
      {loading ? (
        <div
          className="d-flex justify-content-center"
          style={{
            height: "100vh",
            overflow: "hidden",
            backgroundColor: "#FFFFFF",
          }}
        >
          <div className="col-md-6 d-flex flex-column justify-content-center align-items-center position-relative">
            <img
              src={darkLogo}
              alt="logo"
              width={250}
              className="position-absolute"
              style={{ top: "30px" }}
            />
            <video
              src={video}
              style={{filter: "hue-rotate(40deg)"}}
              alt="error"
              width="60%"
              loop
              autoPlay
              muted
              className={`transition ${isTransitioning ? "out" : "in"}`}
            />
            <h2
              className={`text-center mt-4 transition ${
                isTransitioning ? "out" : "in"
              }`}
            >
              {textLoading}
            </h2>
          </div>
        </div>
      ) : (
        <div
          ref={divRef}
          style={{ height: divHeight }}
          className="bg-white py-2 px-5 position-relative"
        >
          <div className="row text-center mb-4 mt-3">
            <div
              className="d-flex col-md-3 text-muted"
              onClick={() => navigate("/")}
            >
              <i
                className="fa-solid fa-chevron-left mt-2 me-2"
                style={{ cursor: "pointer", fontSize: "15px" }}
              ></i>
              <h5 className="mt-2" style={{ cursor: "pointer" }}>
                Voltar para o login
              </h5>
            </div>
            <div className="col-md-6">
              <h1>
                Planos <span className="text-success">Lote Mobile</span>
              </h1>
              <h4>
                Selecione um plano para utilizar no seu sistema Lote Mobile
              </h4>
            </div>
            <div className="col-md-3"></div>
          </div>
          <div className="">
            <Steps
              model={items}
              activeIndex={activeIndex}
              onSelect={(e) => setActiveIndex(e.index)}
              readOnly={!baseDataForm || !plan}
            />
            {activeIndex === 0 && <FormData />}
            {activeIndex === 1 && <Plans />}
            {activeIndex === 2 && <Payment />}
            {/* {divHeight === '100vh' ? (
            <div className="position-absolute bottom-0 start-0 end-0">
              <div className="pt-2 text-center">
                Já possui uma conta? Clique <Link to="/">aqui</Link> para entrar.
              </div>
              <hr className="bg-gray-600 opacity-2" />
              <p className="text-center">
                &copy; IB System Todos os direitos reservados 2024
              </p>
            </div>
          ) : (
            <> */}
            {/* <div className="pt-2 text-center">
            Já possui uma conta? Clique <Link to="/">aqui</Link> para entrar.
          </div>
          <hr className="bg-gray-600 opacity-2" />
          <p className="text-center">
            &copy; IB System Todos os direitos reservados 2024
          </p> */}
            {/* </>
          )} */}
          </div>
        </div>
      )}
    </>
  );
};

export default CreateAccount;
